module.exports = __webpack_public_path__ + "img/invector-architecture.4f848c8d.png";